import { useState } from "react";
import ModalView from "@modals/modalview/ModalView";
import closeIcon from "@assets/icons/close-icon.svg";
import styles from "./ConfirmAction.module.css";

interface ConfirmActionProps {
  isOpen: boolean;
  onClose: () => void;
  onProceed?: (dontShowAgain: boolean) => void;
}

function ConfirmAction({ isOpen, onClose, onProceed }: ConfirmActionProps) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleProceed = () => {
    onProceed?.(dontShowAgain);
    onClose();
  };

  return (
    <ModalView isOpen={isOpen} onClose={onClose}>
      <div className={styles.confirmActionContainer}>
        <div className={styles.closeHeader}>
          <button className={styles.closeBtn} onClick={onClose}>
            <img src={closeIcon} alt="Close" />
          </button>
        </div>
        <div className={styles.confirmActionContent}>
          <div className={styles.confirmActionTitle}>
            <h2>Confirm Action</h2>
          </div>
          <div className={styles.confirmActionDescription}>
          <p>
              Once you click on Proceed, you won't be able to return to this
              question.
            </p>
          </div>
          <div className={styles.dontShowAgainSection}>
            <input
              type="checkbox"
              id="dontShowAgain"
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
            />
            <label htmlFor="dontShowAgain">Don't show this again</label>
          </div>
          <div className={styles.submitButtonSection}>
            <button className={styles.cancelButton} onClick={onClose}>
              Cancel
            </button>
            <button className={styles.proceedButton} onClick={handleProceed}>
              Proceed
            </button>
          </div>
        </div>
      </div>
    </ModalView>
  );
}

export default ConfirmAction;
